module.exports = __webpack_public_path__ + "static/media/features.ad07ebf4.png";